var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loaded-files d-flex"},_vm._l((_vm.files),function(file,index){return _c('div',{key:index},[_c('div',{staticClass:"d-flex align-center"},[_c('span',[_vm._v(_vm._s(file.name ? file.name : file.fileName))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }